import { combineReducers } from 'redux';

import aiParserState, { aiParserInitialState } from './aiParser';
import aiToolsCommonState, { aiToolsCommonInitialState } from './aiToolsCommon';
import aiTransformerState, { aiTransformerInitialState } from './aiTransformer';

export const aiToolsState = combineReducers({ aiParserState, aiTransformerState, aiToolsCommonState })

export const aiToolsInitialState = {
  aiToolsCommonState: aiToolsCommonInitialState,
  aiParserState: aiParserInitialState,
  aiTransformerState: aiTransformerInitialState,
}
